<template>
  <div class="step-two">
    <div v-show="type == 1" class="person">
      <el-form ref="personForm" :model="personForm" :rules="personFormRules" size="small" label-width="120px">
        <el-form-item label="身份证姓名" prop="realName">
          <el-input v-model="personForm.realName" maxlength="30" placeholder="请输入身份证姓名"></el-input>
        </el-form-item>
        <el-form-item label="证件类型" prop="idType">
          <el-select v-model="personForm.idType">
            <el-option label="身份证" :value="1"></el-option>
            <el-option label="护照" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件号码" prop="idNum">
          <el-input v-model="personForm.idNum" maxlength="30" placeholder="请输入证件号码"></el-input>
        </el-form-item>
        <el-form-item label="证件正面" prop="idFrontPic">
          <MyUpload info="仅支持jpg、png, 小于20M" accept="image/png,image/jpeg" :imgKey.sync="personForm.idFrontPic"/>
        </el-form-item>
        <el-form-item label="证件反面" prop="idBackPic">
          <MyUpload info="仅支持jpg、png, 小于20M" accept="image/png,image/jpeg" :imgKey.sync="personForm.idBackPic"/>
        </el-form-item>
      </el-form>
    </div>
    <div v-show="type == 2" class="company">
      <el-form ref="companyForm" :rules="companyFormRules" :model="companyForm"  size="small" label-width="130px">
        <el-form-item label="申请人" prop="realName">
          <el-input v-model="companyForm.realName" maxlength="30" placeholder="请输入生产者"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idNum">
          <el-input v-model="companyForm.idNum" maxlength="18" placeholder="请输入身份证号"></el-input>
        </el-form-item>
        <el-form-item label="公司营业执照号" prop="businessLicNo">
          <el-input v-model="companyForm.businessLicNo" maxlength="30" placeholder="请输入公司营业执照号"></el-input>
        </el-form-item>
        <el-form-item label="公司地址" prop="companyAddr">
          <el-input v-model="companyForm.companyAddr" maxlength="30" placeholder="请输入公司地址"></el-input>
        </el-form-item>
        <el-form-item label="固定电话" prop="landlineTel">
          <el-input v-model="companyForm.landlineTel" maxlength="30" placeholder="请输入公司固定电话"></el-input>
        </el-form-item>
        <el-form-item label="法人身份证正面" prop="idFrontPic">
          <MyUpload info="仅支持jpg、png, 小于20M" :imgKey.sync="companyForm.idFrontPic" />
        </el-form-item>
        <el-form-item label="法人身份证反面" prop="idBackPic">
          <MyUpload info="仅支持jpg、png, 小于20M" :imgKey.sync="companyForm.idBackPic" />
        </el-form-item>
        <el-form-item label="营业执照照片" prop="businessLicPic">
          <MyUpload info="仅支持jpg、png, 小于20M" :imgKey.sync="companyForm.businessLicPic" />
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import MyUpload from '../common/MyUpload'
export default {
  name: 'step-two',
  components: {
    MyUpload
  },
  props: {
    type: {
      type: String
    }
  },
  data() {
    return {
      ossUrl: '',
      ossData: {},
      personForm: {
        realName: '',
        idType: 1,
        idNum: '',
        idFrontPic: '',
        idBackPic: '',
      },
      personFormRules: {
        realName: [{ required: true, message: '请输入身份证姓名', trigger: 'blur' }],
        idNum: [
          { required: true, message: '证件号码', trigger: 'blur' }, 
        ],
        idFrontPic: [
          { required: true, message: '请上传证件正面' },
        ],
        idBackPic: [
          { required: true, message: '请上传证件反面' },
        ],
      },
      companyForm: {
        realName: '',
        idNum: '',
        idFrontPic: '',
        idType: 1,
        idBackPic: '',
        businessLicNo: '',
        businessLicPic: '',
        companyAddr: '',
        landlineTel: '',
      },
      companyFormRules: {
        realName: [{ required: true, message: '请输入法人姓名', trigger: 'blur' }],
        idNum: [{ required: true, message: '请输入身份证号', trigger: 'blur' }],
        idFrontPic: [{ required: true, message: '请上传法人身份证正面照片', trigger: 'blur' }],
        idBackPic: [{ required: true, message: '请上传法人身份证反面照片', trigger: 'blur' }],
        businessLicNo: [{ required: true, message: '请输入公司营业执照号', trigger: 'blur' }],
        businessLicPic: [{ required: true, message: '请上传营业执照正本照片', trigger: 'blur' }],
        companyAddr: [{ required: true, message: '请输入公司地址', trigger: 'blur' }],
      }
    }
  },
  mounted() {},
  methods: {
    getValidate() {
      return this.type == 1 ? this.$refs.personForm.validate() : this.$refs.companyForm.validate()
    },
    getFormData() {
      return { formDataTwo: this.type === '1' ? this.personForm : this.companyForm }
    }
  }
}
</script>

<style lang="less" scoped>
.step-two {
}
</style>



// WEBPACK FOOTER //
// src/components/producerRegister/StepTwo.vue